// Aperçu de la base pour l'invité (spec § 3) : les filtres de la liste des projets traduits en filtres de comptage sur
// toute la base (`base_count_projects`, mêmes clés que l'assistant de la base). La recherche libre devient des mots
// cherchés en début de mot dans le nom et la description : le compte est proche de la liste, pas identique.
// Un filtre que la traduction ne connaît pas donne null : aucun compte plutôt qu'un compte faux.

import { readAmountFilter } from "./amountFilter";

export type TeaserFilters = Record<string, unknown>;

const ALL_CATEGORIES = [
  "water",
  "tunnels_rail",
  "bridges_parking",
  "buildings",
  "other",
];

const empty = (value: unknown) => value == null || value === "";

// Liste au format de PostgREST : (a,b) ou ("a b","c").
const listItems = (value: unknown) =>
  String(value)
    .replace(/^\(|\)$/g, "")
    .split(",")
    .map((item) => item.trim().replace(/^"|"$/g, ""))
    .filter(Boolean);

const day = (value: unknown) => String(value).slice(0, 10);

export const teaserFilters = (
  filterValues: Record<string, unknown>,
): TeaserFilters | null => {
  const filters: TeaserFilters = {};
  let hideOther = false;
  for (const [key, value] of Object.entries(filterValues)) {
    if (empty(value)) continue;
    switch (key) {
      case "q": {
        const words = String(value).split(/\s+/).filter(Boolean);
        if (words.length) filters.words = words;
        break;
      }
      case "phase":
        filters.phases = [String(value)];
        break;
      case "phase@in":
        filters.phases = listItems(value);
        break;
      case "category":
        filters.categories = [String(value)];
        break;
      case "category@in":
        filters.categories = listItems(value);
        break;
      case "category@neq":
        if (value !== "other") return null;
        hideOther = true;
        break;
      case "country":
        filters.countries = [String(value)];
        break;
      case "country@in":
        filters.countries = listItems(value);
        break;
      case "score@gte":
        filters.min_score = Number(value);
        break;
      case "budget_eur@gte":
      case "@or": {
        const amount = readAmountFilter({ [key]: value });
        if (!amount) return null;
        const eur = Math.round(amount.millions * 1_000_000);
        if (amount.includeUnknown) filters.min_eur_or_unknown = eur;
        else filters.min_eur = eur;
        break;
      }
      case "budget_eur@lte":
        filters.max_eur = Number(value);
        break;
      case "created_at@gte":
        filters.created_after = day(value);
        break;
      case "created_at@lt":
        filters.created_before = day(value);
        break;
      case "last_news_at@gte":
        filters.news_after = day(value);
        break;
      case "to_specify":
        filters.to_specify = value === true || value === "true";
        break;
      default:
        return null;
    }
  }
  for (const key of ["min_score", "max_eur"])
    if (key in filters && !Number.isFinite(filters[key] as number)) return null;
  // Sans catégorie choisie, la base écarte « autre » ; la liste ne l'écarte que sur demande.
  if (!filters.categories && !hideOther) filters.categories = ALL_CATEGORIES;
  return filters;
};
